import React from 'react';
import { Pagination, Input, PageHeader, Button } from 'antd';
import { ExportOutlined } from '@ant-design/icons';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { connect } from 'react-redux';
import { getAdReports } from '../../../store/slices/adminSlice';
import { generateCsv, download, mkConfig } from 'export-to-csv';

interface AdItemInfo {
  name?: string;
  type?: string;
}

interface UserInfo {
  name?: string;
  email?: string;
}

interface AdReportItem {
  _id?: string;
  ad?: AdItemInfo;
  user?: UserInfo;
  createdAt?: string;
  [key: string]: any;
}

interface AdreportProps {
  getAdReports: (payload: any) => void;
  adreportData: AdReportItem[];
  totalCount: number;
  form: any;
}

interface AdreportState {
  currentPage: number;
  totalRecord: number;
  search_string: string;
  adreportData: AdReportItem[];
  adreportAllData: AdReportItem[];
  sortValue: string;
  sortOrder: number | ''; //asc / desc
  visible: boolean;
  imageUrl: string;
  loading?: boolean;
}

class Adreport extends React.Component<AdreportProps, AdreportState> {
  constructor(props: AdreportProps) {
    super(props);
    this.state = {
      currentPage: 0,
      totalRecord: 0,
      search_string: '',
      adreportData: [],
      adreportAllData: [],
      sortValue: '',
      sortOrder: '',
      visible: false,
      imageUrl: '',
      loading: false,
    };
  }

  componentDidMount() {
    const obj = {
      search_string: this.state.search_string,
      page: this.state.currentPage,
      sortValue: this.state.sortValue,
      sortOrder: this.state.sortOrder,
      isAllData: false,
    };
    this.props.getAdReports(obj);
    const obj_all = {
      search_string: this.state.search_string,
      page: this.state.currentPage,
      sortValue: this.state.sortValue,
      sortOrder: this.state.sortOrder,
      isAllData: true,
    };
    this.props.getAdReports(obj_all);
  }

  searchString(e: React.ChangeEvent<HTMLInputElement>) {
    this.setState({
      search_string: e.target.value,
    });
    const obj = {
      search_string: e.target.value,
      page: this.state.currentPage,
      sortValue: this.state.sortValue,
      sortOrder: this.state.sortOrder,
      isAllData: false,
    };
    this.props.getAdReports(obj);
  }

  changePage(page: number, pageSize?: number) {
    this.setState({
      currentPage: page - 1,
    });
    const obj = {
      search_string: this.state.search_string,
      page: page - 1,
      sortValue: this.state.sortValue,
      sortOrder: this.state.sortOrder,
      isAllData: false,
    };
    this.props.getAdReports(obj);
  }

  sortData(sortVal: string) {
    const nextOrder = this.state.sortOrder === -1 ? 1 : -1;
    this.setState({
      sortOrder: nextOrder,
    });
    const obj = {
      search_string: this.state.search_string,
      page: this.state.currentPage,
      sortValue: sortVal,
      sortOrder: nextOrder,
      isAllData: false,
    };
    this.props.getAdReports(obj);
  }

  exportToCSV() {
    const csvConfig = mkConfig({
      fieldSeparator: ',',
      quoteStrings: true,
      decimalSeparator: '.',
      useBom: true,
      useKeysAsHeaders: true,
      filename: 'adreport',
    });

    const processData = (data: AdReportItem[]) => {
      return data.map((ad) => {
        const processed: any = ad._id
          ? {
              addName: ad.ad?.name,
              addType: ad.ad?.type,
              userEmail: ad.user?.email,
              clickTime: ad.createdAt ? new Date(ad.createdAt).toLocaleString() : '',
            }
          : ad;
        return processed;
      });
    };

    const sourceData = this.state.totalRecord > 5
      ? this.state.adreportAllData
      : this.state.adreportData;

    const csvData = processData(sourceData);
    const csv = generateCsv(csvConfig)(csvData);
    download(csvConfig)(csv);
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(nextProps: AdreportProps) {
    const data = nextProps.adreportData;
    if (data.length <= 10) {
      this.setState({
        adreportData: data,
        totalRecord: nextProps.totalCount,
        loading: false,
      });
    } else {
      this.setState({ adreportAllData: data, loading: false });
    }
  }

  render() {
    const state = this.state;

    const adreports = state.adreportData.map((x) => {
      return (
        <tr key={x._id}>
          <td>{x?.ad?.name}</td>
          <td>{x?.ad?.type}</td>
          <td>{x?.user?.name}</td>
          <td>{x?.user?.email}</td>
          <td>{x?.createdAt ? new Date(x.createdAt).toLocaleString() : ''}</td>
        </tr>
      );
    });

    return (
      <>
        <div className="box box-default mb-4">
          <PageHeader
            title="Ad Reports"
            subTitle=""
            extra={[
              <Input
                placeholder="Search"
                onChange={this.searchString.bind(this)}
                key="search"
                style={{ width: 'auto' }}
              />,

              <Button key="1" type="default" onClick={this.exportToCSV.bind(this)}>
                <ExportOutlined /> Export to CSV
              </Button>,
            ]}
          />
          <div className="box-body">
            <div className="table-responsive">
              <table className="table">
                <thead>
                  <tr>
                    <th scope="col">Ad Name</th>
                    <th scope="col">Ad Type</th>
                    <th scope="col">User Name</th>
                    <th scope="col">User Email</th>
                    <th scope="col">Created Date</th>
                  </tr>
                </thead>
                <tbody>{adreports}</tbody>
              </table>
            </div>
            <Pagination
              style={{ textAlign: 'right' }}
              pageSize={5}
              defaultCurrent={this.state.currentPage}
              onChange={this.changePage.bind(this)}
              total={this.state.totalRecord ? this.state.totalRecord : 1}
            />
          </div>
        </div>
      </>
    );
  }
}

function mapStateToProps(state: any) {
  return {
    adreportData: state.admin.adreportData,
    totalCount: state.admin.adreportCount,
  };
}

const Adreports = Form.create({ name: 'adreport' })(Adreport as any);
export default connect(mapStateToProps, { getAdReports })(Adreports as any);












